<mat-card dir="rtl">
    <mat-progress-bar mode="indeterminate" color="primary" *ngIf="isSubmitting"></mat-progress-bar>

    <mat-card-header [style.opacity]="isSubmitting ? .6 : 1">
        <mat-card-title>کارت مقصد</mat-card-title>
        <mat-card-subtitle>
            لطفا شماره 16 رقمی ریال پیمنت را وارد کنید
        </mat-card-subtitle>
    </mat-card-header>

    <mat-card-content [style.opacity]="isSubmitting ? .6 : 1">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <mat-form-field>
                <mat-label>شماره 16 رقمی ریال پیمنت</mat-label>
                <input appNumericOnly appAutoFocus dir="ltr" class="text-center"
                    matInput formControlName="cardno" type="text"
                    [value]="form.controls['cardno'].value | creditCard">
                <span matSuffix dir="ltr">
                    <i class="fas fa-credit-card"></i>
                </span>
                <mat-error *ngIf="form.controls['cardno'].hasError('required')">
                    شماره کارت نمی‌تواند خالی باشد
                </mat-error>

                <mat-error *ngIf="form.controls['cardno'].hasError('cardnum')">
                    شماره کارت وارد شده معتبر نمی‌باشد
                </mat-error>
            </mat-form-field>

            <div class="text-center">
                <button mat-raised-button color="primary"
                    [disabled]="isSubmitting">
                    ثبت
                </button>
            </div>
        </form>
    </mat-card-content>

</mat-card>